import { get } from 'lodash'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import APP, { AuthUserSchema, RouterMatchSchema, ServerResponseSchema } from 'app'
import { ProgressBar } from 'ui'
import { withMatch } from 'utils'

import { authAction, authLoginByCredentials } from 'actions/AuthActions'
import {
  SYSTEM_MESSAGE_ACTION,
  SYSTEM_MESSAGE_INITIAL_STATE,
  systemMessageCanceled,
  systemMessageShow,
} from 'actions/SystemMessageActions'
import AppVersion from 'components/ui/AppVersion'
import Site404 from 'pages/site/Site404'
import UserHome from 'pages/user/UserHome'

import { resetFetch, verifyFetch } from '../../actions'
import Footer from '../../components/Footer'
import HomeScreen from '../HomeScreen'
import PrivacyScreen from '../PrivacyScreen'

class WrapperScreen extends PureComponent {
  componentDidMount() {
    const { code, token } = this.props.match.params
    if (code && token) {
      if (window.location?.pathname?.includes('/reset')) {
        this.props.resetFetch(code, token)
      } else {
        this.props.verifyFetch(code, token)
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.reset.loaded && this.props.reset.loaded && !this.props.reset.error) {
      const [data] = this.props.reset.data
      APP.msg = {
        ...APP.msg,
        content: data.content,
        title: data.title,
        token: data.token,
      }
      this.props.authAction('password')
    } else if (!prevProps.verify.loaded && this.props.verify.loaded && !this.props.verify.error) {
      const [data] = this.props.verify.data
      this.props.systemMessageShow({
        ...SYSTEM_MESSAGE_INITIAL_STATE,
        msg: data.content,
        options: [
          {
            ...SYSTEM_MESSAGE_ACTION,
            content: 'OK',
            onClick: () => {
              const accessAuth = data.accessAuth || null
              const accessCode = data.accessCode || null

              if (accessAuth && accessCode) {
                this.props.authLoginByCredentials(accessAuth, accessCode, true)
              }
              this.props.systemMessageCanceled()
              APP.history.replace('/')
            },
            primary: true,
          },
        ],
        title: data.title,
      })
    }
  }

  onRegister = () => this.props.authAction('register')

  render() {
    const { auth, device, match, platform } = this.props
    const { section } = match.params
    const sectionName = match.location?.pathname === '' || section || ''

    let Section
    switch (sectionName) {
      case '': {
        Section = auth.loaded && auth.usr ? UserHome : HomeScreen
        break
      }
      case 'privacy': {
        Section = PrivacyScreen
        break
      }
      default: {
        Section = Site404
      }
    }

    return (
      <div>
        <AppVersion mobile={device.mobile} os={device.os} version={APP.device.appVersion} />
        {auth.loading ? (
          <ProgressBar value={100} />
        ) : (
          <Section
            institutions={get(platform, 'data[0].institutions', [])}
            onRegister={this.onRegister}
            stats={get(platform, 'data[0].stats', [])}
            time={get(platform, 'data[0].time', null)}
            tournament={get(platform, 'data[0].tournament', {})}
            viewer={auth.usr}
          />
        )}
        <Footer />
      </div>
    )
  }
}

WrapperScreen.propTypes = {
  authAction: PropTypes.func.isRequired,
  authLoginByCredentials: PropTypes.func.isRequired,
  device: PropTypes.shape({
    mobile: PropTypes.bool,
    os: PropTypes.string,
  }).isRequired,
  match: RouterMatchSchema.isRequired,
  platform: ServerResponseSchema.isRequired,
  reset: ServerResponseSchema.isRequired,
  resetFetch: PropTypes.func.isRequired,
  systemMessageCanceled: PropTypes.func.isRequired,
  systemMessageShow: PropTypes.func.isRequired,
  verify: ServerResponseSchema.isRequired,
  verifyFetch: PropTypes.func.isRequired,

  auth: PropTypes.shape({
    loaded: PropTypes.bool,
    loading: PropTypes.bool,
    usr: AuthUserSchema,
  }).isRequired,
}

export default connect(
  ({ auth, environment: { device }, site: { platform, reset, verify } }) => ({
    auth,
    device,
    platform,
    reset,
    verify,
  }),
  {
    authAction,
    authLoginByCredentials,
    resetFetch,
    systemMessageCanceled,
    systemMessageShow,
    verifyFetch,
  },
)(withMatch(WrapperScreen))
